<script setup lang="ts">
import ModalFromBot from '@/components/Modal/ModalFromBot.vue';
import Header from '@/components/Header.vue';
import { useAccountStore } from '@/stores/account';
import { $BigNumber,filterNumberValue, getTokenImg } from '@/utils';
import { onMounted } from 'vue';
import { computed } from 'vue';
import _service from "@/service";
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { closeToast, showLoadingToast, showToast } from 'vant';
import router from '@/router';
import { isStarNest } from '@/utils/starnest';
import ModalInMiddle from '@/components/Modal/ModalInMiddle.vue';
type starType = { name: string; starNumber:number, price: number };
const accountStore = useAccountStore();
const isShowPayModal = ref<boolean>(false)
const isShowLanguageModal = ref<boolean>(false)
  // !(import.meta.env.VITE_APP_NET === 'uat')
const showLimitModal = ref<boolean>(false)

const starData = ref<starType>({name:'',starNumber:0,price:0});
const number = ref<number|null>();
const clickTimes = ref<number>(0);
const payChannelData = ref<any>({});
const appUserInfo = ref<any>({});
const password = ref<any>('');
const { t, locale } = useI18n({ useScope: "global" });
const lang = ref<string>(locale.value);
// 测试环境固定的starId
const starSpuId = 659
const starSkuId = 132
const starPropertyId = 25




const price = computed(()=>{
  return `${$BigNumber((number.value || 0)).times(starData.value?.price || 0).div(100)} USD`
})


onMounted(()=>{
  if (localStorage.getItem('SHOWLIMIT') === 'true') {
    showLimitModal.value = false
  }
  console.log(isStarNest,'isStarNest');
  showLoadingToast({
    message: t("Loading"),
    duration: 0,
  });
  setTimeout(async() => {
    let all = Promise.all([getAppUserInfo(),getStar()])
    all.then((result:any)=>{
      closeToast()
    })
  }, 1000);
  
})

const accountName = computed(() => {
  return accountStore.getUserInfo.name;
});

const getAppUserInfo = async () => {
  try {
    const {data} = await _service.getUserInfo({})
    const {nickname,mobile} = data
    appUserInfo.value = {
      receiverName:nickname,
      receiverMobile:mobile
    }
 } catch (error) {
  console.log(error,'getAppUserInfo error');
 }
}

const getStar = async() => {
  const {data} = await _service.getProductDetail({id:starSpuId})
  const _sku = data.skus.filter((item:any)=>{return item.id === starSkuId})[0]
  const starNumber = Number(_sku.properties.filter((item:any)=>{return item.propertyId === starPropertyId})[0].valueName.split(' ')[0]) || 1
  const _data = {
    name:data.name,
    starNumber:starNumber,
    price:_sku?.price
  }
  starData.value = _data
}


const handleCreateOrder  =  async() => {
  if (!number.value) {
    showToast('请输入购买数量')
    return false
  }
  try {
    showLoadingToast({
      message: t("Loading"),
      duration: 0,
    });
    const postData = {
      items:[{
        skuId:starSkuId,
        count:Number($BigNumber(number.value || 0).div(starData.value?.starNumber))
      }],
      pointStatus:false,
      deliveryType:3,
      ...appUserInfo.value,
      remark:''
    }
    const {data} = await _service.createStarOrder(postData)
    const payOrderId = data.payOrderId
    showLoadingToast({
      message: t('The order was created successfully and payment is being redirected'),
      duration: 0,
    });
    console.log(starData.value,'starData--');
    
    sessionStorage.setItem('ORDER_DATA',JSON.stringify({starData:{...starData.value,initialPrice:starData.value?.price || 0,totalPrice:Number($BigNumber(number.value || 0).times(starData.value?.price || 0)),quantity:number.value},orderData:data}))
    router.push('/star-pay')
    closeToast()
  } catch (error) {
    showToast(t('Failed to create order'))
    closeToast()
  }
}

const fee = computed(()=>{
  console.log(payChannelData.value,'payChannelData');
  
  const price = $BigNumber((number.value || 0)).times(starData.value?.price || 0)
  return $BigNumber(payChannelData.value?.feeRate || 0).times(price)
})

const clickLogo = () => {
  clickTimes.value++;
  sessionStorage.setItem("clickLogoTImes", `${clickTimes.value}`);
  if (clickTimes.value >= 7) {
    var vConsole = new window.VConsole();
  }
  // var vConsole = new window.VConsole();
};

const limitFn = ()=>{
  if (password.value === '10') {
  showLimitModal.value = false
  localStorage.setItem('SHOWLIMIT','true')
}}
</script>

<template>
  <div class="star-layout">
    <!-- <div class="header flex-row-between-center">
      <div class="wallet flex-row-start-center" @click="clickLogo"> 
        <i class="icon"></i> <span class="address">{{ accountName ? accountName : $t("Connect Wallet") }}</span>
      </div>
      <i class="locale" @click="isShowLanguageModal = true"></i>
    </div> -->
    <Header></Header>
    <div class="row-box-wrapper media-375">
        <div class="row-box">
          <div class="row-title flex-row-between-center">
            <span>{{t('Purchase Quantity')}}</span>
            <span class="black"></span>
          </div>
          <div class="inputer flex-row-between-center">
            <input type="text" class="number-font" placeholder="0.00" v-model="number" @input="(event:any)=>{
                  number = filterNumberValue(event.target.value,0)
            }">
            <div class="token number-font">
              <i class="token-icon"></i> STAR
            </div>
          </div>
          <div class="select-list">
            <div class="select-list-item" @click="number = 200">200</div>
            <div class="select-list-item" @click="number = 500">500</div>
            <div class="select-list-item" @click="number = 1000">1000</div>
            <div class="select-list-item" @click="number = 2000">2000</div>
          </div>
        </div>
        <div class="row-box">
          <div class="row-title flex-row-between-center">
            <span>{{t('Total Amount')}}</span>
            <span class="black">1 STAR = {{starData?.price / 100}} USD</span>
          </div>
          <div class="inputer flex-row-center-center">
            <input type="text" class="number-font center" v-model="price" disabled>
          </div>
        </div>
        <!-- <div class="row-box">
          <div class="row-title flex-row-between-center">
            <span>{{t('Payment Method')}}</span>
          </div>
          <div class="inputer flex-row-between-center"  @click="isShowPayModal = true">
            <span>{{payTypeList[payTypeIndex]?.name}}</span>
            <i class="drop-down-icon"></i>
          </div>
          <div class="inputer flex-row-between-center"  @click="isShowChainOptionsModal = true" v-if="payTypeList[payTypeIndex].type === 'chain'">
            <span>{{payTypeList[payTypeIndex]?.options[chainPayTypeIndex].name}} <span class="gray">({{payTypeList[payTypeIndex]?.options[chainPayTypeIndex].type}})</span> </span>
            <i class="drop-down-icon"></i>
          </div>
        </div> -->
    </div>
    <div class="purchase-btn media-375 flex-row-center-center" @click="handleCreateOrder">{{t('Purchase')}}</div>
    <ModalInMiddle v-model:isShow="showLimitModal" title="抱歉">
      <div class="confirm-modal">
        <div class="flex-row-center-center">仍在测试阶段 暂时无法进入</div>
        <input style="width: 100%;" type="text" v-model="password">
        <div class="btn-group flex-row-center-center">
          <div class="btn flex-row-center-center" @click="limitFn">确定</div>
        </div>
      </div>
    </ModalInMiddle>
  </div>
</template>

<style lang="scss" scoped>
.row-title{
  font-size: 12px;
  color: #9C9CAA;
  .black{
    color: #565662;
  }
}
.star-layout{
  height: 100%;
  min-height: 100vh;
  background: #070B14;
  padding: 0 16px;
  .header{
    padding: 10px 0;
    .wallet{
      display: flex;
      padding: 8px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: 10px;
      border: 1px solid #303342;
      font-size: 12px;
      color: #9C9CAA;
      .icon{
        width: 16px;
        height: 16px;
        background: url(../../assets/star/wallet.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
    .locale{
      width: 24px;
      height: 24px;
      background: url(../../assets/star/locale.svg);
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
  .row-box-wrapper{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    margin-top: 34px;
  }
  .row-box{
    width: 100%;
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    .inputer{
      border-radius: 12px;
      background: #1F212D;
      width: 100%;
      height: 58px;
      padding: 8px 14px;
      margin-top: 10px;
      
      input{
        flex:1;
        color: #fff;
        font-size: 18px;
        &::placeholder{
          color: #9C9CAA;
        }
        &.center{
          text-align: center;
        }
      }
      .gray{
        font-size: 14px;
        color: #9C9CAA;
      }
      .drop-down-icon{
        width: 24px;
        height: 24px;
        background: url(../../assets/drop-down-icon.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
      .token{
        display: flex;
        padding: 7px 12px;
        justify-content: center;
        align-items: center;
        gap: 6px;
        border-radius: 14px;
        background: #070B14;
        font-size: 18px;
        font-weight: 700;
        color: #1CF2E4;
        .token-icon{
          width: 28px;
          height: 28px;
          background: url(../../assets/star/token-icon.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
    .select-list{
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      gap: 13px;
      margin-top: 12px;
      &-item{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 28px;
        border-radius: 8px;
        border: 0.6px solid #545769;
        font-size: 14px;
        color: #565662;
      }
    }
  }
  .purchase-btn{
    width: 100%;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(111deg, #FFF853 4.98%, #6EEF94 56.05%, #2AD8CD 95.37%);
    color: #070B14;
    font-size: 16px;
    margin-top: 60px;
    &:active{
      @include btnHover;
    }
  }
}

.language-modal{
  gap: 24px;
  padding: 24px 16px;
  .title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }
  .lang-list {
    width: 100%;
    &-item {
      width: 100%;
      height: 52px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      &.active {
        .check {
          display: block;
        }
      }
      .check {
        display: none;
        width: 16px;
        height: 16px;
        background: url(../../assets/check.svg);
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
}

</style>
